module.exports = __webpack_public_path__ + "_assets/img/01. 樂天桃園棒球場.8970dc20.jpg";